import type { MouseEvent } from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import { IconButton, Tooltip } from 'components/ui';
import { PushPin } from 'icons';
import type { SelectionPinButtonProps } from './SelectionPinButton.props';
import { selectionPinButtonClasses, SelectionPinButtonOutlinedIcon } from './SelectionPinButton.styles';

const SelectionPinButton = ({ id, isPinned, onToggle, title }: SelectionPinButtonProps) => {
  const theme = useTheme();
  const selectionPinIconColor = alpha(theme.palette.neutral.black, 0.6);

  return (
    <Tooltip title={isPinned ? 'Unpin' : 'Pin'}>
      <IconButton
        aria-label="pin"
        onClick={(event: MouseEvent) => {
          event.stopPropagation();
          event.preventDefault();
          onToggle?.(id, title, isPinned);
        }}
        size="small"
        sx={{ ml: 1 }}
      >
        {isPinned ? (
          <PushPin fontSize="small" htmlColor={selectionPinIconColor} />
        ) : (
          <SelectionPinButtonOutlinedIcon
            className={selectionPinButtonClasses.outlinedIcon}
            fontSize="small"
            htmlColor={selectionPinIconColor}
          />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default SelectionPinButton;
